export function getHeader(category) {
  const originHeaders = [
    {
      text: 'STT',
      value: 'stt',
      align: 'center',
      sortable: false,
      show: true,
      width: '5%'
    },
    {
      text: 'Tên học sinh',
      value: 'name',
      align: 'left',
      sortable: false,
      show: true,
      width: '35%'
    },
    {
      text: 'Ngày sinh',
      value: 'dob',
      align: 'left',
      sortable: false,
      show: true,
      width: '15%'
    },
    {
      text: 'Giới tính',
      value: 'gender',
      align: 'left',
      sortable: false,
      show: true,
      width: '15%'
    },
    {
      text: 'Lớp',
      value: 'currentClass',
      align: 'left',
      sortable: false,
      show: true,
      width: '10%'
    },
    {
      text: 'Trạng thái',
      value: 'status',
      align: 'left',
      sortable: false,
      show: true,
      width: '10%'
    }
  ]
  if (category === 'custom') {
    originHeaders.push({
      text: 'Thao tác',
      value: 'action',
      align: 'center',
      sortable: false,
      show: true,
      width: '10%'
    })
    return originHeaders
  } else {
    return originHeaders
  }
}
